import React from 'react';
import ConsentBanner from './src/components/consent-banner';
import { initConsent } from './src/components/consent';

// Returning visitors who already accepted: load trackers on first render
// (after hydration). New visitors get nothing until they click Accept.
export const onInitialClientRender = () => {
	initConsent();
};

// Render the consent banner on every page.
export const wrapPageElement = ({ element }) => (
	<>
		{element}
		<ConsentBanner />
	</>
);

// Logs when the client route changes
export const onRouteUpdate = ({ location, prevLocation }) => {
	// First-party attribution (NOT consent-gated — see src/components/consent.js)
	if (
		typeof window !== 'undefined' &&
		window.localStorage &&
		!window.localStorage.getItem('lNdUrL')
	) {
		window.localStorage.setItem('lNdUrL', location.href);
		window.localStorage.setItem('lNdUrLDtIme', new Date());
	}

	window.localStorage.setItem('crNtPaTH', location.href);
	window.localStorage.setItem(
		'prevPaTHnAme',
		prevLocation ? prevLocation.href : null
	);

	// The removed gatsby-plugin-google-tagmanager used to push this event on
	// every SPA route change. Re-emit it manually (50ms delay so the new page
	// title is set) so GTM pageview triggers keep working after consent.
	if (typeof window !== 'undefined') {
		setTimeout(() => {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ event: 'gatsby-route-change' });
		}, 50);
	}
};
